import { faEye } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Avatar from '@scoir/avatar'

import { useCanTestApp } from 'store/user/hooks'

import { PreviewApplicationButton } from './PreviewApplicationButton'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    justifyContent: 'space-between',
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
}))

const PreviewApplicationAsStudentBanner = ({ configurationId }: { configurationId: string }) => {
  const classes = useStyles()
  const canTestApp = useCanTestApp()
  if (!canTestApp) {
    return null
  }
  return (
    <Paper className={classes.root}>
      <Box
        display="flex"
        alignItems="center"
        gridGap={16}
      >
        <Avatar
          iconColor="info"
          variant="circular"
          fallbackIcon={<FontAwesomeIcon icon={faEye} />}
        />
        <div>
          <Typography>
            <b>Preview the student application</b>
          </Typography>
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            Read-only access still lets you see exactly what students will experience.
          </Typography>
        </div>
      </Box>
      <PreviewApplicationButton
        variant="contained"
        configurationId={configurationId}
      />
    </Paper>
  )
}

export default PreviewApplicationAsStudentBanner
